import React, { useCallback } from 'react';
import { ButtonItem } from '@atlaskit/menu';
import { log } from '@atlassian/jira-common-util-logging';
import createBoardLegacy from '@atlassian/jira-create-board-legacy';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { MenuItemProps } from '../types';
import { messages } from './messages';

export function CreateBoardMenuItem({ onClosePopup }: MenuItemProps) {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const handleClick = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'createBoard clicked',
				actionSubject: 'menuItem',
			}),
			'createBoard clicked',
		);
		onClosePopup && onClosePopup();
		createBoardLegacy().catch((error) => {
			log.safeErrorWithoutCustomerData(
				'backlog.modal.create-board.failure',
				'Failed to open legacy Create board dialog',
				error,
			);
		});
	}, [createAnalyticsEvent, onClosePopup]);

	return <ButtonItem onClick={handleClick}>{formatMessage(messages.displayText)}</ButtonItem>;
}
